export const GET_ORGANIZATION_TIMESHEET_BY_EMPLOYEE =
  'GET_ORGANIZATION_TIMESHEET_BY_EMPLOYEE'
export const GET_ORGANIZATION_TIMESHEET_BY_PUPIL =
  'GET_ORGANIZATION_TIMESHEET_BY_PUPIL'
